import LookupLocationsRequestModel from '../../../generated/types/model/request/LookupLocationsRequestModel';

export default class LookupLocationsRequestViewModel extends LookupLocationsRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
